import { render, staticRenderFns } from "./NavbarBottom.vue?vue&type=template&id=1c92bd0a"
import script from "./NavbarBottom.vue?vue&type=script&lang=js"
export * from "./NavbarBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports